/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface ChatFileAndContentIDs {
  /** 메세지 ID */
  _id: string;
  /** 채팅 모델이 귀속된 채팅방 ID */
  chatRoomID: string;
  /** 발송된 채팅 모델의 타입 */
  type?: number;
  /** 채팅 내 전달된 메세지 */
  content: string;
  /** 채팅 내 전달된 메세지 (영어) */
  englishContent?: string;
  /** 번역된 메세지 */
  translatedContent?: string;
  /** 번역된 메세지를 재번역한 메세지 */
  retranslatedContent?: string;
  /** 번역 완료 여부 */
  isTranslated?: boolean;
  /** 채팅 발송 여부 */
  isSendContent?: boolean;
  /** 채팅 발송 유저의 Type */
  userType?: number;
  /** 채팅을 발송한 유저의 ID */
  userID?: string;
  /** 첨부된 파일의 ID 배열 */
  fileIDs?: File[];
  /** 채팅으로 전송된 운동콘텐츠 ID 배열 */
  videoContentIDs?: VideoContentUserForChat[];
  /** 채팅으로 전송된 병원 이벤트 - 이벤트에 대한 ID */
  heventID?: HospitalEventForChat;
  /** 채팅으로 전송된 병원 이벤트 - 홈케어 상품에 대한 ID */
  haftercareID?: HospitalAftercareForChat;
  /** 채팅으로 전송된 병원 공지사항에 대한 ID */
  hnoticeID?: HospitalNoticeForChat;
  /** 채팅의 북마크 여부 */
  isBookmark: boolean;
  /** 채팅의 북마크 지정 시간 */
  bookmarkedAt?: boolean;
  /** 채팅의 발송 성공 여부 */
  isSent?: boolean;
  /** 채팅의 발송 상태. success, failed 만 존재 */
  status?: string;
  /** 발송된 채팅 언어 */
  language?: string;
  /** 자동화 알고리즘 메시지 정보 */
  algorithmMessageId?: {
    /**
     * 알고리즘 메시지 ID
     * @example "66e3cc76db11c46a6a57b715"
     */
    _id?: string;
    /** 메시지 내용 */
    content?: {
      /**
       * 메시지 텍스트
       * @example "안녕하세요!"
       */
      text?: string;
      /**
       * 이미지 업로드 이후 생성된 파일 ID - 이미지 업로드 시 클라이언트 측에서 상담 자동화 메시지의 경우 이미지 개수 20개까지 마케팅 자동화의 경우 이미지 개수 1개까지 업로드 제한하는 로직 필요
       * @example "66f11a223a4e84397d604db7"
       */
      image?: string;
      /**
       * 비디오 업로드 이후 생성된 파일 ID - 상담 알고리즘에서만 사용되는 필드 - 비디오 업로드 시 클라이언트 측에서 비디오 개수 1개까지 업로드 제한하는 로직 필요
       * @example "66c594000469d43a28d5cde7"
       */
      video?: string;
      /**
       * 비디오 콘텐츠 ID - 운동 영상 - 상담 알고리즘에서만 사용되는 필드 - VideoContent 컬렉션 ID
       * @example "63d1db9d813fcf1c99a34f18"
       */
      workoutVideo?: string;
      /**
       * 병원 콘텐츠 ID - 상담 알고리즘에서만 사용되는 필드 - HospitalAftercare 컬렉션 ID
       * @example "66da9fb0b0acc956b4b723e4"
       */
      homecareContent?: string;
      /**
       * 이벤트 ID - 상담 알고리즘에서만 사용되는 필드 - HospitalEvent 컬렉션 ID
       * @example "633d07bc828afe1f2ce8c504"
       */
      event?: string;
      /** 설문 정보 */
      survey?: {
        /**
         * 설문 질문
         * @example "설문 질문"
         */
        question?: string;
        /**
         * 설문 옵션 목록
         * @example ["옵션1","옵션2"]
         */
        answers?: string[];
      };
    };
  };
  /** 설문 응답 정보 */
  surveyResponseId?: {
    /**
     * 설문 응답 ID
     * @example "66e3cc76db11c46a6a57b715"
     */
    _id?: string;
    /**
     * 설문 응답 옵션 인덱스 - 첫 번째 선택이 0 부터 1, 2, ... 순으로 시작
     * @example 2
     */
    answerIndex?: number;
    /**
     * 설문 응답 일시
     * @example "2025-01-03T11:00:00.000Z"
     */
    answeredAt?: string;
  };
  /** 채팅의 삭제 여부 */
  isRemoved?: boolean;
  /** 미사용 */
  user?: Record<string, any>;
  /** 파일 전송 시  파일 업로드 이전에 임시로 생성된 경우에 사용될 ID */
  tempID?: string;
  /** 채팅 마커에 사용될 이모지 배열 */
  markers?: any[];
  /** 발송한 유저의 이름 */
  userName?: string;
  /** 채팅 발신자의 직책 */
  jobType?: string;
  /** 유저의 실제 이름 */
  userRealName?: string;
  /** 발송한 유저의 프로필 이미지 URL */
  photoPath?: string;
  /** 상담 알고리즘의 Identifier (임시) */
  caName?: string;
  /** 상담 알고리즘의 사이클 Identifier */
  caCycle?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 채팅 삭제일시 */
  removedAt?: string;
  /** 채팅 전송일시. 애프터닥 채팅인 경우 생성일시와 발송일시 동일 */
  sentAt: string;
  /** 채팅 전송 실패 일시. 실패했을 경우 기록 */
  failedAt?: string;
  /** AI 상담 코치 데이터 */
  aiCoach?: {
    /**
     * 감지된 언어 코드 (ISO 639-1 기반, 중국어는 zh-CN/zh-TW로 구분)
     * @example "zh-CN"
     */
    language?: string;
    source?: "COACH" | "GLOBAL_COORDINATOR";
    /** 권장 답변 */
    responseText?: string;
    /** 번역된 권장 답변 (글로벌 코디네이터인 경우) */
    translatedResponseText?: string;
    /** 답변 가이드 */
    responseGuide?: string;
    /** 자동응대 대기 시간 */
    automaticResponseIntervalMinutes?: number;
    /** 코치 데이터 생성 상태 */
    status: "PROCESSING" | "FAILED" | "COMPLETED";
    /** 핸즈오프 케이스 발생 시 관련 데이터 */
    handsoff?: {
      /** 핸즈오프 이유 */
      reason: "APPOINTMENT_NEED_CONFIRMATION" | "UNABLE_TO_RESPOND";
      /** 핸즈오프 메시지. LLM이 상담사 이관이 필요하다고 판단한 경우 템플릿에 설정된 메시지가 포함됨 */
      message?: string;
      /** 번역된 핸즈오프 메시지. 외국어 대화 시 hand_off_message를 해당 언어로 번역한 값 */
      translatedMessage?: string;
    };
    /** LLM이 file_search로 참조한 파일명 목록 */
    references?: string[];
    /** 소스 앱(글로벌 코디네이터 등)이 비활성화 상태에서 생성된 가이드인지 여부 */
    isSourceAppInactive?: boolean;
  };
  /** AI 세션 데이터 */
  session?: {
    /** 세션 아이디 */
    _id: string;
    /** 세션 요약 텍스트 */
    summary?: string;
    /** 현재 진행중인지 여부 */
    isOngoing?: boolean;
  };
}

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface VideoContentUserForChat {
  /** 발송된 고객 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 운동콘텐츠 제목 */
  title?: string;
  /** 운동콘텐츠 부제목 */
  subtitle?: string;
  /** 운동콘텐츠 카테고리 (구 치료부위 카테고리) */
  categories?: VideoContentCategoryNameTopParent[];
  /** 일주일 중 실천할 횟수(주 n회)  기본값 주 3회 */
  doPerWeek?: number;
  /** 처방기간 (n주 동안 진행)  기본값 2주 */
  duration?: number;
  /** 영상 썸네일 FileID */
  thumbnailFileID?: FilePaths;
  /** 병원 홈케어 콘텐츠 고유ID */
  vchID?: string;
}

export interface VideoContentCategoryNameTopParent {
  /** 홈케어 콘텐츠 카테고리 고유ID */
  _id?: string;
  /** 운동콘텐츠 카테고리명 */
  categoryName?: string;
  /** 카테고리 대 여부 */
  isTop?: boolean;
  /** 카테고리 중 여부 */
  isParent?: boolean;
}

export interface FilePaths {
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths?: string[];
}

export interface HospitalEventForChat {
  /** 병원 이벤트 고유 ID */
  _id?: string;
  /** 이벤트 제목 */
  title?: string;
  /** 이벤트 기본 가격 */
  price?: number;
  /** 이벤트의 정액 할인액 */
  salePrice?: number;
  /** 이벤트의 정률 할인의 할인율 */
  saleRate?: number;
  /** 이벤트 시작 일자 */
  startDate?: string;
  /** 이벤트 종료 일자 */
  endDate?: string;
  /** 이벤트 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 이벤트 대표 이미지 fileID */
  representImage?: FilePaths;
  /** 이벤트의 활성화 여부 */
  isActive?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
}

export interface HospitalAftercareForChat {
  /** 홈케어 상품 고유 ID */
  _id?: string;
  /** 홈케어 상품 제목 */
  title?: string;
  /** 홈케어 상품 기본 가격 */
  price?: number;
  /** 홈케어 상품의 정액 할인액 */
  salePrice?: number;
  /** 홈케어 상품의 정률 할인의 할인율 */
  saleRate?: number;
  /** 홈케어 상품 시작 일자 */
  startDate?: string;
  /** 홈케어 상품 종료 일자 */
  endDate?: string;
  /** 홈케어 상품 시작 및 종료시간 설정 여부. */
  isLimitedTime?: boolean;
  /** 홈케어 상품 대표 이미지 fileID */
  representImage?: FilePaths;
  /** 홈케어 상품의 활성화 여부 */
  isActive?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
}

export interface HospitalNoticeForChat {
  /** 병원 공지사항 고유 ID */
  _id?: string;
  /** 해당 공지사항의 타이틀 문자열 */
  title?: string;
  /** 해당 공지사항의 html tag 문자열 */
  content?: string;
  /** 삭제 여부 플래그 */
  isRemoved?: boolean;
  /** 최초 작성일시 */
  createdAt?: string;
}

export interface Chat {
  /** 채팅 모델이 귀속된 채팅방 ID */
  chatRoomID?: string;
  /** 발송된 채팅 모델의 타입 */
  type?: number;
  /** 채팅 내 전달된 메세지 */
  content?: string;
  /** 채팅 내 전달된 메세지 (영어) */
  englishContent?: string;
  /** 번역된 메세지 */
  translatedContent?: string;
  /** 번역된 메세지를 재번역한 메세지 */
  retranslatedContent?: string;
  /** 번역 완료 여부 */
  isTranslated?: boolean;
  /** 채팅 발송 유저의 Type */
  userType?: number;
  /** 채팅을 발송한 유저의 ID */
  userID?: string;
  /** 첨부된 파일의 ID 배열 */
  fileIDs?: string;
  /** 채팅으로 전송된 운동콘텐츠 ID 배열 */
  videoContentIDs?: string[];
  /** 채팅으로 전송된 병원 이벤트 - 이벤트에 대한 ID */
  heventID?: string;
  /** 채팅으로 전송된 병원 이벤트 - 홈케어 상품에 대한 ID */
  haftercareID?: string;
  /** 채팅으로 전송된 병원 공지사항 ID */
  hnoticeID?: string;
  /** 채팅의 북마크 여부 */
  isBookmark?: boolean;
  /** 채팅의 북마크 지정 시간 */
  bookmarkedAt?: boolean;
  /** 채팅의 발송 성공 여부 */
  isSent?: boolean;
  /** 채팅의 발송 상태. success, failed 만 존재 */
  status?: string;
  /** 발송된 채팅 언어 */
  language?: string;
  /** 채팅의 삭제 여부 */
  isRemoved?: boolean;
  /** 미사용 */
  user?: Record<string, any>;
  /** 파일 전송 시  파일 업로드 이전에 임시로 생성된 경우에 사용될 ID */
  tempID?: string;
  /** 채팅 마커에 사용될 이모지 배열 */
  markers?: any[];
  /** 발송한 유저의 이름 */
  userName?: string;
  /** 채팅 발신자의 직책 */
  jobType?: string;
  /** 유저의 실제 이름 */
  userRealName?: string;
  /** 발송한 유저의 프로필 이미지 URL */
  photoPath?: string;
  /** 상담 알고리즘의 Identifier (임시) */
  caName?: string;
  /** 상담 알고리즘의 사이클 Identifier */
  caCycle?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 채팅 삭제일시 */
  removedAt?: string;
  /** 채팅 전송일시. 애프터닥 채팅인 경우 생성일시와 발송일시 동일 */
  sentAt?: string;
  /** 채팅 전송 실패 일시. 실패했을 경우 기록 */
  failedAt?: string;
}

export interface TranslateControllerTranslateContentBodyRequest {
  /** 병원 ID */
  hospitalID?: string;
  /** 채팅방 ID */
  chatRoomID: string;
  /** 메세지 */
  content: string;
}

export interface TranslateControllerTranslateContentResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 번역 결과 */
    translatedContent: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatControllerPaginationResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 채팅 모델이 귀속된 채팅방 ID */
    chatRoomID?: string;
    /** 발송된 채팅 모델의 타입 */
    type?: number | null;
    /** 채팅 내 전달된 메세지 */
    content: string;
    /** 번역된 메세지 */
    translatedContent?: string;
    /** 번역된 메세지를 재번역한 메세지 */
    retranslatedContent?: string;
    /**
     * 번역 완료 여부
     * @default false
     */
    isTranslated?: boolean;
    /**
     * 채팅 발송 여부
     * @default false
     */
    isSendContent?: boolean;
    /** 채팅 발송 유저의 Type */
    userType?: number | null;
    /** 채팅을 발송한 유저의 ID */
    userID?: string;
    /** 첨부된 파일의 ID 배열 */
    fileIDs?: any[];
    /** 채팅으로 전송된 운동콘텐츠 ID 배열 */
    videoContentIDs?: any[];
    /** 채팅으로 전송된 병원 이벤트 - 이벤트에 대한 ID */
    heventID?: any;
    /** 채팅으로 전송된 병원 이벤트 - 홈케어 상품에 대한 ID */
    haftercareID?: any;
    /** 채팅으로 전송된 병원 공지사항에 대한 ID */
    hnoticeID?: any;
    /**
     * 채팅의 북마크 여부
     * @default false
     */
    isBookmark: boolean;
    /** 채팅의 북마크 지정 시간 */
    bookmarkedAt?: string;
    /** 미사용 */
    user?: Record<string, any>;
    /** 파일 전송 시  파일 업로드 이전에 임시로 생성된 경우에 사용될 ID */
    tempID?: string;
    /** 채팅 마커에 사용될 이모지 배열 */
    markers?: any[];
    /** 발송한 유저의 이름 */
    userName?: string;
    /** 채팅 발신자의 직책 */
    jobType?: string;
    /** 유저의 실제 이름 */
    userRealName?: string;
    /** 발송한 유저의 프로필 이미지 URL */
    photoPath?: string;
    /** 상담 알고리즘의 Identifier (임시) */
    caName?: string;
    /** 상담 알고리즘의 사이클 Identifier */
    caCycle?: string;
    /** 생성일 */
    createdAt?: string;
    /** 마지막 수정일 */
    updatedAt?: string;
    /** 메시지의 ID */
    _id: string;
    /** 메시지 발송일 */
    sentAt: string;
    /** AI 상담 코치 데이터 */
    aiCoach?: {
      language?: string | null;
      source?: "COACH" | "GLOBAL_COORDINATOR" | null;
      responseText?: string | null;
      translatedResponseText?: string | null;
      responseGuide?: string | null;
      automaticResponseIntervalMinutes?: number | null;
      status?: "PROCESSING" | "FAILED" | "COMPLETED" | null;
      handsoff?: {
        reason?: "APPOINTMENT_NEED_CONFIRMATION" | "UNABLE_TO_RESPOND" | null;
        message?: string | null;
        translatedMessage?: string | null;
      };
      references?: string[] | null;
      isSourceAppInactive?: boolean | null;
      hasDeferredSideEffects?: boolean | null;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatControllerSearchResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 채팅 모델이 귀속된 채팅방 ID */
    chatRoomID?: string;
    /** 발송된 채팅 모델의 타입 */
    type?: number | null;
    /** 채팅 내 전달된 메세지 */
    content: string;
    /** 번역된 메세지 */
    translatedContent?: string;
    /** 번역된 메세지를 재번역한 메세지 */
    retranslatedContent?: string;
    /**
     * 번역 완료 여부
     * @default false
     */
    isTranslated?: boolean;
    /**
     * 채팅 발송 여부
     * @default false
     */
    isSendContent?: boolean;
    /** 채팅 발송 유저의 Type */
    userType?: number | null;
    /** 채팅을 발송한 유저의 ID */
    userID?: string;
    /** 첨부된 파일의 ID 배열 */
    fileIDs?: any[];
    /** 채팅으로 전송된 운동콘텐츠 ID 배열 */
    videoContentIDs?: any[];
    /** 채팅으로 전송된 병원 이벤트 - 이벤트에 대한 ID */
    heventID?: any;
    /** 채팅으로 전송된 병원 이벤트 - 홈케어 상품에 대한 ID */
    haftercareID?: any;
    /** 채팅으로 전송된 병원 공지사항에 대한 ID */
    hnoticeID?: any;
    /**
     * 채팅의 북마크 여부
     * @default false
     */
    isBookmark: boolean;
    /** 채팅의 북마크 지정 시간 */
    bookmarkedAt?: string;
    /** 미사용 */
    user?: Record<string, any>;
    /** 파일 전송 시  파일 업로드 이전에 임시로 생성된 경우에 사용될 ID */
    tempID?: string;
    /** 채팅 마커에 사용될 이모지 배열 */
    markers?: any[];
    /** 발송한 유저의 이름 */
    userName?: string;
    /** 채팅 발신자의 직책 */
    jobType?: string;
    /** 유저의 실제 이름 */
    userRealName?: string;
    /** 발송한 유저의 프로필 이미지 URL */
    photoPath?: string;
    /** 상담 알고리즘의 Identifier (임시) */
    caName?: string;
    /** 상담 알고리즘의 사이클 Identifier */
    caCycle?: string;
    /** 생성일 */
    createdAt?: string;
    /** 마지막 수정일 */
    updatedAt?: string;
    /** 메시지의 ID */
    _id: string;
    /** 메시지 발송일 */
    sentAt: string;
    /** AI 상담 코치 데이터 */
    aiCoach?: {
      language?: string | null;
      source?: "COACH" | "GLOBAL_COORDINATOR" | null;
      responseText?: string | null;
      translatedResponseText?: string | null;
      responseGuide?: string | null;
      automaticResponseIntervalMinutes?: number | null;
      status?: "PROCESSING" | "FAILED" | "COMPLETED" | null;
      handsoff?: {
        reason?: "APPOINTMENT_NEED_CONFIRMATION" | "UNABLE_TO_RESPOND" | null;
        message?: string | null;
        translatedMessage?: string | null;
      };
      references?: string[] | null;
      isSourceAppInactive?: boolean | null;
      hasDeferredSideEffects?: boolean | null;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatControllerFindConsultationGuidesResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    algorithmType: "CONSULTATION" | "MARKETING";
    algorithm?: {
      name?: string;
      targetTreatmentTags?: string[];
      /** @format date */
      startedAt?: string;
    };
    lastBrandMessage?: {
      _id?: string;
      name: string;
      sendingDateTime: string;
      content: {
        text?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
        };
        image?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        wideImage?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        carousel?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          title: string;
          text: string;
          imageUrl: string;
          imageLink?: string;
        }[];
      };
      targeting?: "M" | "N" | "I";
    };
    lastMessage?: {
      sendingType: "BASIC" | "REVISIT_INDUCEMENT" | "SURVEY" | "FIRST_MESSAGE" | "COMMON" | "BRAND_MESSAGE";
      name?: string;
      content?: {
        /**
         * 알고리즘 메시지 내용
         * @example "알고리즘 메시지 내용"
         */
        text: string;
        /**
         * 알고리즘 메시지 이미지 파일 아이디
         * @example "673c8075bbc0f01e9e6aa31f"
         */
        image?: string;
        /**
         * 알고리즘 메시지 동영상
         * @example "알고리즘 메시지 동영상"
         */
        video?: string;
        /**
         * 알고리즘 메시지 운동 동영상
         * @example "알고리즘 메시지 운동 동영상"
         */
        workoutVideo?: string;
        /**
         * 알고리즘 메시지 홈케어 내용
         * @example "알고리즘 메시지 홈케어 내용"
         */
        homecareContent?: string;
        /**
         * 알고리즘 메시지 이벤트
         * @example "알고리즘 메시지 이벤트"
         */
        event?: string;
        survey?: {
          /**
           * 설문 질문
           * @example "설문 질문"
           */
          question?: string;
          /**
           * 설문 답변 목록
           * @example ["설문 답변 1","설문 답변 2"]
           */
          answers?: string[];
          /**
           * 설문 답변 인덱스
           * @example 2
           */
          surveyAnswerIndex?: number;
          /**
           * 설문 답변 인덱스에 해당하는 값
           * @example "매우 만족"
           */
          surveyAnswerValue?: string;
        };
      };
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      /** @format date */
      sentAt?: string;
      contentType?: "TEXT" | "IMAGE" | "VIDEO" | "WORKOUT_VIDEO" | "HOME_CARE_PRODUCT" | "EVENT" | "SURVEY";
      contentText?: string;
      daysAfter?: number;
      /** @format date */
      sendingDateTime?: string;
    };
    treatmentTag?: {
      categoryName?: string;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatMCreateHAftercareHandlerBodyRequest {
  hserviceID: string;
  chatRoomID: string;
  haftercareID: string;
}

export interface ChatMCreateHAftercareHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    chatRoomID: string;
    type: number;
    content?: string;
    translatedContent?: string;
    retranslatedContent?: string;
    isTranslated?: boolean;
    userType: number;
    userID: string;
    fileIDs: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    }[];
    videoContentIDs: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      subtitle: string;
      caregoryName?: string[];
      searchKeyword?: string[];
      exerciseType: string;
      stimulateMuscles?: string;
      stimulateMusclesImageID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      description: string;
      relatedDiseases: string;
      exerciseSet?: {
        title: string;
        titleEn: string;
        description: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        timestamp: number;
      }[];
      meterial?: {
        name: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
      };
      precaution: string;
      doPerWeek: number;
      duration: number;
      endDate?: number;
      message?: string;
      thumbnailFileID: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      videoFileID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      isDetail: boolean;
      isHidden: boolean;
      isRemoved: boolean;
      isRecommend: boolean;
      isRead: boolean;
      totalVideoLength: number;
      viewCount?: number;
    }[];
    heventID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    haftercareID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    hnoticeID?: {
      /** MongoDB Identifier */
      _id: string;
      index?: number;
      title: string;
      content: string;
      viewCount?: number;
      isRemoved?: boolean;
      hospitalID?: string;
      writerID?: string;
      modifierID?: string;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    };
    /** 알고리즘 메시지 ID */
    algorithmMessageId?: string;
    /** 설문 응답 ID */
    surveyResponseId?: string;
    /** 치료태그 자동 발송으로 만들어진 채팅 메시지일 경우 발송 트리거 치료태그 ID. 수동 채팅 및 다른 자동화에는 채워지지 않는다. */
    treatmentCautionTagID?: string;
    isBookmark?: boolean;
    /** @format date */
    bookmarkedAt?: string;
    tempID?: string;
    markers: string[];
    userName?: string;
    jobType?: string;
    userRealName?: string;
    photoPath?: string;
    caName?: string;
    caCycle?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    sentAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatMCreateHEventHandlerBodyRequest {
  hserviceID: string;
  chatRoomID: string;
  heventID: string;
}

export interface ChatMCreateHEventHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    chatRoomID: string;
    type: number;
    content?: string;
    translatedContent?: string;
    retranslatedContent?: string;
    isTranslated?: boolean;
    userType: number;
    userID: string;
    fileIDs: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    }[];
    videoContentIDs: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      subtitle: string;
      caregoryName?: string[];
      searchKeyword?: string[];
      exerciseType: string;
      stimulateMuscles?: string;
      stimulateMusclesImageID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      description: string;
      relatedDiseases: string;
      exerciseSet?: {
        title: string;
        titleEn: string;
        description: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        timestamp: number;
      }[];
      meterial?: {
        name: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
      };
      precaution: string;
      doPerWeek: number;
      duration: number;
      endDate?: number;
      message?: string;
      thumbnailFileID: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      videoFileID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      isDetail: boolean;
      isHidden: boolean;
      isRemoved: boolean;
      isRecommend: boolean;
      isRead: boolean;
      totalVideoLength: number;
      viewCount?: number;
    }[];
    heventID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    haftercareID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    hnoticeID?: {
      /** MongoDB Identifier */
      _id: string;
      index?: number;
      title: string;
      content: string;
      viewCount?: number;
      isRemoved?: boolean;
      hospitalID?: string;
      writerID?: string;
      modifierID?: string;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    };
    /** 알고리즘 메시지 ID */
    algorithmMessageId?: string;
    /** 설문 응답 ID */
    surveyResponseId?: string;
    /** 치료태그 자동 발송으로 만들어진 채팅 메시지일 경우 발송 트리거 치료태그 ID. 수동 채팅 및 다른 자동화에는 채워지지 않는다. */
    treatmentCautionTagID?: string;
    isBookmark?: boolean;
    /** @format date */
    bookmarkedAt?: string;
    tempID?: string;
    markers: string[];
    userName?: string;
    jobType?: string;
    userRealName?: string;
    photoPath?: string;
    caName?: string;
    caCycle?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    sentAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatMCreateReservationHandlerBodyRequest {
  hserviceID: string;
  chatRoomID: string;
}

export interface ChatMCreateReservationHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    chatRoomID: string;
    type: number;
    content?: string;
    translatedContent?: string;
    retranslatedContent?: string;
    isTranslated?: boolean;
    userType: number;
    userID: string;
    fileIDs: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    }[];
    videoContentIDs: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      subtitle: string;
      caregoryName?: string[];
      searchKeyword?: string[];
      exerciseType: string;
      stimulateMuscles?: string;
      stimulateMusclesImageID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      description: string;
      relatedDiseases: string;
      exerciseSet?: {
        title: string;
        titleEn: string;
        description: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        timestamp: number;
      }[];
      meterial?: {
        name: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
      };
      precaution: string;
      doPerWeek: number;
      duration: number;
      endDate?: number;
      message?: string;
      thumbnailFileID: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      videoFileID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      isDetail: boolean;
      isHidden: boolean;
      isRemoved: boolean;
      isRecommend: boolean;
      isRead: boolean;
      totalVideoLength: number;
      viewCount?: number;
    }[];
    heventID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    haftercareID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    hnoticeID?: {
      /** MongoDB Identifier */
      _id: string;
      index?: number;
      title: string;
      content: string;
      viewCount?: number;
      isRemoved?: boolean;
      hospitalID?: string;
      writerID?: string;
      modifierID?: string;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    };
    /** 알고리즘 메시지 ID */
    algorithmMessageId?: string;
    /** 설문 응답 ID */
    surveyResponseId?: string;
    /** 치료태그 자동 발송으로 만들어진 채팅 메시지일 경우 발송 트리거 치료태그 ID. 수동 채팅 및 다른 자동화에는 채워지지 않는다. */
    treatmentCautionTagID?: string;
    isBookmark?: boolean;
    /** @format date */
    bookmarkedAt?: string;
    tempID?: string;
    markers: string[];
    userName?: string;
    jobType?: string;
    userRealName?: string;
    photoPath?: string;
    caName?: string;
    caCycle?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    sentAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatMCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: number;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatMFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    chatRoomID: string;
    type: number;
    content?: string;
    translatedContent?: string;
    retranslatedContent?: string;
    isTranslated?: boolean;
    userType: number;
    userID: string;
    fileIDs: {
      /** MongoDB Identifier */
      _id: string;
      paths: string[];
      aws?: {
        ETag: string;
        Location: string;
        Key: string;
        key: string;
        size?: {
          width?: number;
          height?: number;
        } | null;
        fileSize: number;
        fileName: string;
      }[];
    }[];
    videoContentIDs: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      subtitle: string;
      caregoryName?: string[];
      searchKeyword?: string[];
      exerciseType: string;
      stimulateMuscles?: string;
      stimulateMusclesImageID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      description: string;
      relatedDiseases: string;
      exerciseSet?: {
        title: string;
        titleEn: string;
        description: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
        timestamp: number;
      }[];
      meterial?: {
        name: string;
        thumbnailFileID: {
          /** MongoDB Identifier */
          _id: string;
          paths: string[];
          aws?: {
            ETag: string;
            Location: string;
            Key: string;
            key: string;
            size?: {
              width?: number;
              height?: number;
            } | null;
            fileSize: number;
            fileName: string;
          }[];
        };
      };
      precaution: string;
      doPerWeek: number;
      duration: number;
      endDate?: number;
      message?: string;
      thumbnailFileID: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      videoFileID?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      isDetail: boolean;
      isHidden: boolean;
      isRemoved: boolean;
      isRecommend: boolean;
      isRead: boolean;
      totalVideoLength: number;
      viewCount?: number;
    }[];
    heventID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    haftercareID?: {
      /** MongoDB Identifier */
      _id: string;
      title: string;
      price?: number;
      saleType?: string;
      salePrice?: number;
      saleRate?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      isLimitedTime?: boolean;
      type?: string;
      content?: string;
      fileIDs?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      }[];
      isActive: boolean;
      isRemoved: boolean;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
    };
    hnoticeID?: {
      /** MongoDB Identifier */
      _id: string;
      index?: number;
      title: string;
      content: string;
      viewCount?: number;
      isRemoved?: boolean;
      hospitalID?: string;
      writerID?: string;
      modifierID?: string;
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
    };
    /** 알고리즘 메시지 ID */
    algorithmMessageId?: string;
    /** 설문 응답 ID */
    surveyResponseId?: string;
    /** 치료태그 자동 발송으로 만들어진 채팅 메시지일 경우 발송 트리거 치료태그 ID. 수동 채팅 및 다른 자동화에는 채워지지 않는다. */
    treatmentCautionTagID?: string;
    isBookmark?: boolean;
    /** @format date */
    bookmarkedAt?: string;
    tempID?: string;
    markers: string[];
    userName?: string;
    jobType?: string;
    userRealName?: string;
    photoPath?: string;
    caName?: string;
    caCycle?: string;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt?: string;
    /** @format date */
    sentAt?: string;
    /**
     * fileIDs 가 존재할 경우 하위에 담겨있는 URL 목록
     * @example ["https://example.com/image.jpg"]
     */
    fileUrls?: string[];
    /** @example {"question":"설문 질문","answers":["설문 답변 1","설문 답변 2"]} */
    survey?: {
      /**
       * 설문 질문
       * @example "설문 질문"
       */
      question?: string;
      /**
       * 설문 답변 목록
       * @example ["설문 답변 1","설문 답변 2"]
       */
      answers?: string[];
      /**
       * 설문 답변 인덱스
       * @example 2
       */
      surveyAnswerIndex?: number;
      /**
       * 설문 답변 인덱스에 해당하는 값
       * @example "매우 만족"
       */
      surveyAnswerValue?: string;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomsLatestConsultationGuideHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 상담 가이드
     * @example "상담 가이드"
     */
    consultationGuide?: string;
    /** 최신 상담 자동화 알고리즘 메시지 */
    lastConsultationAlgorithmMessage?: {
      /**
       * 알고리즘 메시지 아이디
       * @example "673c8075bbc0f01e9e6aa31f"
       */
      id: string;
      /**
       * 알고리즘 이름 또는 명칭
       * @example "쥬베룩 시술"
       */
      algorithmName: string;
      /**
       * 알고리즘 메시지 이름
       * @example "알고리즘 메시지 이름"
       */
      name: string;
      /**
       * 알고리즘 메시지 발송 타입
       * @example "SMS"
       */
      sendingType: string;
      /**
       * 카카오로 발송 여부
       * @example true
       */
      isSentToKakao: boolean;
      /**
       * 알고리즘 메시지 발송 일시
       * @example "2021-01-01T00:00:00"
       */
      sendingDateTime?: string;
      /**
       * 알고리즘 메시지 발송 일시
       * @example 1
       */
      daysAfter?: number;
      /**
       * 알고리즘 메시지 발송 시간
       * @example "09:00"
       */
      timeOfDay?: string;
      /**
       * 알고리즘 메시지 내용
       * @example "알고리즘 메시지 내용"
       */
      contentText?: string;
      /**
       * 알고리즘 메시지 채팅 타입 - 11100: 텍스트, 11300: 이미지, 11400: 동영상, 11410: 홈케어 콘텐츠, 11700: 이벤트, 11710: 홈케어상품, 13900: 설문
       * @example 1
       */
      chatType?: number;
      /**
       * 알고리즘 메시지 컨텐츠 타입
       * @example "TEXT"
       */
      contentType?: "TEXT" | "IMAGE" | "VIDEO" | "WORKOUT_VIDEO" | "HOME_CARE_PRODUCT" | "EVENT" | "SURVEY";
      content: {
        /**
         * 알고리즘 메시지 내용
         * @example "알고리즘 메시지 내용"
         */
        text: string;
        /**
         * 알고리즘 메시지 이미지 파일 아이디
         * @example "673c8075bbc0f01e9e6aa31f"
         */
        image?: string;
        /**
         * 알고리즘 메시지 동영상
         * @example "알고리즘 메시지 동영상"
         */
        video?: string;
        /**
         * 알고리즘 메시지 운동 동영상
         * @example "알고리즘 메시지 운동 동영상"
         */
        workoutVideo?: string;
        /**
         * 알고리즘 메시지 홈케어 내용
         * @example "알고리즘 메시지 홈케어 내용"
         */
        homecareContent?: string;
        /**
         * 알고리즘 메시지 이벤트
         * @example "알고리즘 메시지 이벤트"
         */
        event?: string;
        survey?: {
          /**
           * 설문 질문
           * @example "설문 질문"
           */
          question?: string;
          /**
           * 설문 답변 목록
           * @example ["설문 답변 1","설문 답변 2"]
           */
          answers?: string[];
          /**
           * 설문 답변 인덱스
           * @example 2
           */
          surveyAnswerIndex?: number;
          /**
           * 설문 답변 인덱스에 해당하는 값
           * @example "매우 만족"
           */
          surveyAnswerValue?: string;
        };
      };
      /**
       * 상담 가이드 표시 여부
       * @example true
       */
      showConsultationGuide?: boolean;
      /**
       * 상담 가이드
       * @example "상담 가이드"
       */
      consultationGuide?: string;
      /**
       * 메시지 발송 일시
       * @example "2021-01-01T00:00:00"
       */
      messageSentAt?: string;
    };
    /** 최신 마케팅 자동화 알고리즘 메시지 */
    lastMarketingAlgorithmMessage?: {
      /**
       * 알고리즘 메시지 아이디
       * @example "673c8075bbc0f01e9e6aa31f"
       */
      id: string;
      /**
       * 알고리즘 이름 또는 명칭
       * @example "쥬베룩 시술"
       */
      algorithmName: string;
      /**
       * 알고리즘 메시지 이름
       * @example "알고리즘 메시지 이름"
       */
      name: string;
      /**
       * 알고리즘 메시지 발송 타입
       * @example "SMS"
       */
      sendingType: string;
      /**
       * 카카오로 발송 여부
       * @example true
       */
      isSentToKakao: boolean;
      /**
       * 알고리즘 메시지 발송 일시
       * @example "2021-01-01T00:00:00"
       */
      sendingDateTime?: string;
      /**
       * 알고리즘 메시지 발송 일시
       * @example 1
       */
      daysAfter?: number;
      /**
       * 알고리즘 메시지 발송 시간
       * @example "09:00"
       */
      timeOfDay?: string;
      /**
       * 알고리즘 메시지 내용
       * @example "알고리즘 메시지 내용"
       */
      contentText?: string;
      /**
       * 알고리즘 메시지 채팅 타입 - 11100: 텍스트, 11300: 이미지, 11400: 동영상, 11410: 홈케어 콘텐츠, 11700: 이벤트, 11710: 홈케어상품, 13900: 설문
       * @example 1
       */
      chatType?: number;
      /**
       * 알고리즘 메시지 컨텐츠 타입
       * @example "TEXT"
       */
      contentType?: "TEXT" | "IMAGE" | "VIDEO" | "WORKOUT_VIDEO" | "HOME_CARE_PRODUCT" | "EVENT" | "SURVEY";
      content: {
        /**
         * 알고리즘 메시지 내용
         * @example "알고리즘 메시지 내용"
         */
        text: string;
        /**
         * 알고리즘 메시지 이미지 파일 아이디
         * @example "673c8075bbc0f01e9e6aa31f"
         */
        image?: string;
        /**
         * 알고리즘 메시지 동영상
         * @example "알고리즘 메시지 동영상"
         */
        video?: string;
        /**
         * 알고리즘 메시지 운동 동영상
         * @example "알고리즘 메시지 운동 동영상"
         */
        workoutVideo?: string;
        /**
         * 알고리즘 메시지 홈케어 내용
         * @example "알고리즘 메시지 홈케어 내용"
         */
        homecareContent?: string;
        /**
         * 알고리즘 메시지 이벤트
         * @example "알고리즘 메시지 이벤트"
         */
        event?: string;
        survey?: {
          /**
           * 설문 질문
           * @example "설문 질문"
           */
          question?: string;
          /**
           * 설문 답변 목록
           * @example ["설문 답변 1","설문 답변 2"]
           */
          answers?: string[];
          /**
           * 설문 답변 인덱스
           * @example 2
           */
          surveyAnswerIndex?: number;
          /**
           * 설문 답변 인덱스에 해당하는 값
           * @example "매우 만족"
           */
          surveyAnswerValue?: string;
        };
      };
      /**
       * 상담 가이드 표시 여부
       * @example true
       */
      showConsultationGuide?: boolean;
      /**
       * 상담 가이드
       * @example "상담 가이드"
       */
      consultationGuide?: string;
      /**
       * 메시지 발송 일시
       * @example "2021-01-01T00:00:00"
       */
      messageSentAt?: string;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomsConsultationGuidesHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    algorithmType: "CONSULTATION" | "MARKETING";
    algorithm?: {
      name?: string;
      targetTreatmentTags?: string[];
      /** @format date */
      startedAt?: string;
    };
    lastBrandMessage?: {
      _id?: string;
      name: string;
      sendingDateTime: string;
      content: {
        text?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
        };
        image?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        wideImage?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          text: string;
          imageUrl: string;
          imageLink?: string;
        };
        carousel?: {
          buttons: {
            name: string;
            webLink?: {
              urlMobile: string;
              urlPc?: string;
            };
            bizForm?: {
              bizFormKey: string;
              bizFormId?: string;
            };
            appLink?: {
              schemeIos?: string;
              schemeAndroid?: string;
              urlMobile?: string;
              urlPc?: string;
            };
            messageDelivery?: Record<string, any>;
          }[];
          coupon?: {
            type:
              | "DISCOUNT_BY_PRICE"
              | "DISCOUNT_BY_PERCENT"
              | "DISCOUNT_DELIVERY"
              | "PRODUCT_FREE"
              | "PRODUCT_PROMOTION";
            /** 쿠폰 상세 설명 */
            description: string;
            urlMobile: string;
            urlPc?: string;
            variable?: string;
            schemeAndroid?: string;
            schemeIos?: string;
          };
          title: string;
          text: string;
          imageUrl: string;
          imageLink?: string;
        }[];
      };
      targeting?: "M" | "N" | "I";
    };
    lastMessage?: {
      sendingType: "BASIC" | "REVISIT_INDUCEMENT" | "SURVEY" | "FIRST_MESSAGE" | "COMMON" | "BRAND_MESSAGE";
      name?: string;
      content?: {
        /**
         * 알고리즘 메시지 내용
         * @example "알고리즘 메시지 내용"
         */
        text: string;
        /**
         * 알고리즘 메시지 이미지 파일 아이디
         * @example "673c8075bbc0f01e9e6aa31f"
         */
        image?: string;
        /**
         * 알고리즘 메시지 동영상
         * @example "알고리즘 메시지 동영상"
         */
        video?: string;
        /**
         * 알고리즘 메시지 운동 동영상
         * @example "알고리즘 메시지 운동 동영상"
         */
        workoutVideo?: string;
        /**
         * 알고리즘 메시지 홈케어 내용
         * @example "알고리즘 메시지 홈케어 내용"
         */
        homecareContent?: string;
        /**
         * 알고리즘 메시지 이벤트
         * @example "알고리즘 메시지 이벤트"
         */
        event?: string;
        survey?: {
          /**
           * 설문 질문
           * @example "설문 질문"
           */
          question?: string;
          /**
           * 설문 답변 목록
           * @example ["설문 답변 1","설문 답변 2"]
           */
          answers?: string[];
          /**
           * 설문 답변 인덱스
           * @example 2
           */
          surveyAnswerIndex?: number;
          /**
           * 설문 답변 인덱스에 해당하는 값
           * @example "매우 만족"
           */
          surveyAnswerValue?: string;
        };
      };
      showConsultationGuide?: boolean;
      consultationGuide?: string;
      /** @format date */
      sentAt?: string;
      contentType?: "TEXT" | "IMAGE" | "VIDEO" | "WORKOUT_VIDEO" | "HOME_CARE_PRODUCT" | "EVENT" | "SURVEY";
      contentText?: string;
      daysAfter?: number;
      /** @format date */
      sendingDateTime?: string;
    };
    treatmentTag?: {
      categoryName?: string;
    };
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AnsweringChatsProcessingBatchHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 처리 대상 카운트
     * @example 10
     */
    processingTargetCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AnsweringChatsProcessingBatchForV1HandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 처리 대상 카운트
     * @example 10
     */
    processingTargetCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiChatElFindParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /** (optional) 북마크 여부 */
  isBookmark?: boolean;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiChatElFindData = ApiResponse & {
  data: ChatFileAndContentIDs[];
};

export interface ApiChatElFindDateParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /**
   * (required) 조회할 날짜. YYYY-MM-DD 형식으로 전송
   * @example "2024-10-02"
   */
  date: string;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
}

export type ApiChatElFindDateData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export interface ApiChatElFindIdParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /** (required) 채팅 ID */
  _id: string;
  /**
   * (required) 조회 방향. prev - 이전 next - 이후 both - 양방향
   * @default "prev"
   */
  direction: string;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. direction에 따라 고정됨. prev -1, next 1 */
  way?: number;
}

export type ApiChatElFindIdData = ApiResponse & {
  data: ChatFileAndContentIDs[];
};

export interface ApiChatElFindLastParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
}

export type ApiChatElFindLastData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export interface ApiChatElFindOneParams {
  /** (required) 채팅 ObjectId */
  _id: string;
}

export type ApiChatElFindOneData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export interface ApiChatElCountParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
}

export type ApiChatElCountData = ApiResponse & {
  data: number;
};

export type ApiChatElUpdateMarkerData = ApiResponse & {
  data: Chat;
};

export type ApiChatElUpdateBookmarkData = ApiResponse & {
  data: Chat;
};

export type ApiChatElRemoveData = ApiResponse & {
  data: Chat;
};

export type ApiChatElSendHnoticeData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export type ApiChatElSendHeventData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export type ApiChatElSendHaftercareData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export type ApiChatElSendVcuData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export type ApiChatElTranslateData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export interface ApiChatHmFindParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /** (optional) 북마크 여부 */
  isBookmark?: boolean;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiChatHmFindData = ApiResponse & {
  data: ChatFileAndContentIDs[];
};

export interface ApiChatHmFindOneParams {
  /** (required) 채팅 ObjectId */
  _id: string;
}

export type ApiChatHmFindOneData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export interface ApiChatHmCountParams {
  /** (required) 채팅방 ID */
  chatRoomID: string;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
}

export type ApiChatHmCountData = ApiResponse & {
  data: number;
};

export type ApiChatHmRemoveData = ApiResponse & {
  data: Chat;
};

export type ApiChatHmTranslateData = ApiResponse & {
  data: ChatFileAndContentIDs;
};

export type TranslateControllerTranslateContentData = TranslateControllerTranslateContentResponse;

export interface ChatControllerPaginationParams {
  /** 채팅방 ID */
  chatRoomID: string;
  /**
   * 건너뛸 건수
   * @default "20"
   */
  skip?: string;
  /**
   * 조회할 건수
   * @default "20"
   */
  limit?: string;
}

export type ChatControllerPaginationData = ChatControllerPaginationResponse;

export interface ChatControllerSearchParams {
  /** 채팅방 ID */
  chatRoomID: string;
  /**
   * 검색 키워드
   * @minLength 1
   */
  keyword: string;
  /**
   * 스킵할 수
   * @default 0
   */
  skip?: number | null;
  /**
   * 가져오고자 하는 길이
   * @default 20
   */
  limit?: number | null;
}

export type ChatControllerSearchData = ChatControllerSearchResponse;

export interface ChatControllerFindConsultationGuidesParams {
  /**
   * 서비스 또는 환자 아이디
   * @example "673c22bb2e1e7b0c870de9a9"
   */
  hserviceID: string;
}

export type ChatControllerFindConsultationGuidesData = ChatControllerFindConsultationGuidesResponse;

export type ChatMCreateHAftercareHandlerData = ChatMCreateHAftercareHandlerResponse;

export type ChatMCreateHEventHandlerData = ChatMCreateHEventHandlerResponse;

export type ChatMCreateReservationHandlerData = ChatMCreateReservationHandlerResponse;

export interface ChatMCountHandlerParams {
  chatRoomID: string;
}

export type ChatMCountHandlerData = ChatMCountHandlerResponse;

export interface ChatMFindHandlerParams {
  chatRoomID: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type ChatMFindHandlerData = ChatMFindHandlerResponse;

export interface ChatRoomsLatestConsultationGuideHandlerParams {
  /**
   * 서비스 또는 환자 아이디
   * @example "673c22bb2e1e7b0c870de9a9"
   */
  hserviceID: string;
  /**
   * 병원 아이디
   * @example "673c22bb2e1e7b0c870de9a9"
   */
  hospitalID: string;
}

export type ChatRoomsLatestConsultationGuideHandlerData = ChatRoomsLatestConsultationGuideHandlerResponse;

export interface ChatRoomsConsultationGuidesHandlerParams {
  /**
   * 서비스 또는 환자 아이디
   * @example "673c22bb2e1e7b0c870de9a9"
   */
  hserviceID: string;
}

export type ChatRoomsConsultationGuidesHandlerData = ChatRoomsConsultationGuidesHandlerResponse;

export type AnsweringChatsProcessingBatchHandlerData = AnsweringChatsProcessingBatchHandlerResponse;

export type AnsweringChatsProcessingBatchForV1HandlerData = AnsweringChatsProcessingBatchForV1HandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElFind
     * @summary 채팅방 내 채팅내역 조회
     * @request GET:/v3/api/chat/el/find
     * @deprecated
     * @secure
     * @response `200` `ApiChatElFindData` \[\{Chat\}\] 채팅방 ID 내 포함된 채팅 객체 배열
     */
    apiChatElFind: (query: ApiChatElFindParams, params: RequestParams = {}) =>
      this.request<ApiChatElFindData, any>({
        path: `/v3/api/chat/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElFindDate
     * @summary 채팅방 내 특정 날짜 기준, 처음 발생한 첫 번째 채팅 내역 조회. 시스템 채팅 포함
     * @request GET:/v3/api/chat/el/find/date
     * @secure
     * @response `200` `ApiChatElFindDateData` \{Chat\} 채팅 객체
     */
    apiChatElFindDate: (query: ApiChatElFindDateParams, params: RequestParams = {}) =>
      this.request<ApiChatElFindDateData, any>({
        path: `/v3/api/chat/el/find/date`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElFindId
     * @summary 채팅방의 특정 채팅 기준 이전 또는 다음 채팅 조회. 기준이 되는 채팅 id 값을 포함하여 호출
     * @request GET:/v3/api/chat/el/find/id
     * @secure
     * @response `200` `ApiChatElFindIdData` \[\{Chat\}\] 채팅방 ID 내 포함된 채팅 객체 배열
     */
    apiChatElFindId: (query: ApiChatElFindIdParams, params: RequestParams = {}) =>
      this.request<ApiChatElFindIdData, any>({
        path: `/v3/api/chat/el/find/id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElFindLast
     * @summary 채팅방의 가장 최근 발송된 채팅 단건 조회. 시스템 채팅 포함
     * @request GET:/v3/api/chat/el/find/last
     * @secure
     * @response `200` `ApiChatElFindLastData` \{Chat\} 채팅 객체
     */
    apiChatElFindLast: (query: ApiChatElFindLastParams, params: RequestParams = {}) =>
      this.request<ApiChatElFindLastData, any>({
        path: `/v3/api/chat/el/find/last`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElFindOne
     * @summary 채팅 ObjectId로 단일 조회
     * @request GET:/v3/api/chat/el/find/one
     * @secure
     * @response `200` `ApiChatElFindOneData` \{Chat\} 채팅 객체
     */
    apiChatElFindOne: (query: ApiChatElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiChatElFindOneData, any>({
        path: `/v3/api/chat/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElCount
     * @summary 채팅방 내 전체 채팅내역 수 조회
     * @request GET:/v3/api/chat/el/count
     * @secure
     * @response `200` `ApiChatElCountData` 전체 채팅 수
     */
    apiChatElCount: (query: ApiChatElCountParams, params: RequestParams = {}) =>
      this.request<ApiChatElCountData, any>({
        path: `/v3/api/chat/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElUpdateMarker
     * @summary 채팅 마커 업데이트
     * @request POST:/v3/api/chat/el/update/marker
     * @secure
     * @response `200` `ApiChatElUpdateMarkerData` \{Chat\} 수정된 채팅 객체
     */
    apiChatElUpdateMarker: (
      data: {
        /** 채팅마커를 수정하고자 하는 채팅 객체의 ID */
        _id: string;
        markers: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElUpdateMarkerData, any>({
        path: `/v3/api/chat/el/update/marker`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElUpdateBookmark
     * @summary 채팅의 북마크 업데이트. 채팅방 공통 적용
     * @request POST:/v3/api/chat/el/update/bookmark
     * @secure
     * @response `200` `ApiChatElUpdateBookmarkData` \{Chat\} 북마크 값이 변경된 채팅 객체
     */
    apiChatElUpdateBookmark: (
      data: {
        /** 채팅 북마크를 수정하고자 하는 채팅 객체의 ID */
        _id: string;
        /** 북마크 여부 */
        isBookmark: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElUpdateBookmarkData, any>({
        path: `/v3/api/chat/el/update/bookmark`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElRemove
     * @summary 채팅의 삭제 여부 수정. 현재는 전송 실패 케이스에 대해서만 삭제 가능
     * @request POST:/v3/api/chat/el/remove
     * @secure
     * @response `200` `ApiChatElRemoveData` \{Chat\} 삭제된 채팅 객체
     */
    apiChatElRemove: (
      data: {
        /** 삭제하고자 하는 채팅 객체의 ID */
        _id: string;
        /** 삭제 여부 */
        isRemoved: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElRemoveData, any>({
        path: `/v3/api/chat/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElSendHnotice
     * @summary 채팅방 내 병원 공지사항 채팅 전송
     * @request POST:/v3/api/chat/el/send/hnotice
     * @secure
     * @response `200` `ApiChatElSendHnoticeData` \{Chat\} 전송된 Chat 객체
     */
    apiChatElSendHnotice: (
      data: {
        /** (required) 전송할 채팅방 ObjectId */
        chatRoomID: string;
        /** (required) 전송할 병원 공지사항 ObjectId */
        hnoticeID: string;
        /** (optional) 채팅 타입. */
        chatType?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElSendHnoticeData, any>({
        path: `/v3/api/chat/el/send/hnotice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElSendHevent
     * @summary 채팅방 내 병원 이벤트 채팅 전송
     * @request POST:/v3/api/chat/el/send/hevent
     * @secure
     * @response `200` `ApiChatElSendHeventData` \{Chat\} 전송된 Chat 객체
     */
    apiChatElSendHevent: (
      data: {
        /** (required) 전송할 채팅방 ObjectId */
        chatRoomID: string;
        /** (required) 전송할 병원 이벤트 ObjectId */
        heventID: string;
        /** (optional) 채팅 타입. */
        chatType?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElSendHeventData, any>({
        path: `/v3/api/chat/el/send/hevent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElSendHaftercare
     * @summary 채팅방 내 병원 홈케어 상품 채팅 전송
     * @request POST:/v3/api/chat/el/send/haftercare
     * @secure
     * @response `200` `ApiChatElSendHaftercareData` \{Chat\} 전송된 Chat 객체
     */
    apiChatElSendHaftercare: (
      data: {
        /** (required) 전송할 채팅방 ObjectId */
        chatRoomID: string;
        /** (required) 전송할 병원 홈케어 상품 ObjectId */
        haftercareID: string;
        /** (optional) 채팅 타입. */
        chatType?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElSendHaftercareData, any>({
        path: `/v3/api/chat/el/send/haftercare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElSendVcu
     * @summary 채팅방 내 홈케어 콘텐츠 채팅 전송
     * @request POST:/v3/api/chat/el/send/vcu
     * @secure
     * @response `200` `ApiChatElSendVcuData` \{Chat\} 전송된 Chat 객체
     */
    apiChatElSendVcu: (
      data: {
        /** (required) 전송할 채팅방 ObjectId */
        chatRoomID: string;
        /** (required) 전송할 병원 홈케어 콘텐츠 ObjectId */
        vchIDs: string[];
        /** (optional) 채팅 타입. */
        chatType?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElSendVcuData, any>({
        path: `/v3/api/chat/el/send/vcu`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatElTranslate
     * @summary 채팅방 내 채팅 즉시 번역
     * @request POST:/v3/api/chat/el/translate
     * @secure
     * @response `200` `ApiChatElTranslateData` \{Chat\} 전송된 Chat 객체
     */
    apiChatElTranslate: (
      data: {
        /** (required) 번역할 채팅 ObjectId */
        chatID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatElTranslateData, any>({
        path: `/v3/api/chat/el/translate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatHmFind
     * @summary 병원 상담 모바일 앱 - 채팅방 내 채팅내역 조회
     * @request GET:/v3/api/chat/hm/find
     * @deprecated
     * @secure
     * @response `200` `ApiChatHmFindData` \[\{Chat\}\] 채팅방 ID 내 포함된 채팅 객체 배열
     */
    apiChatHmFind: (query: ApiChatHmFindParams, params: RequestParams = {}) =>
      this.request<ApiChatHmFindData, any>({
        path: `/v3/api/chat/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatHmFindOne
     * @summary 병원 상담 모바일 앱 - 채팅 ObjectId로 단일 조회
     * @request GET:/v3/api/chat/hm/find/one
     * @secure
     * @response `200` `ApiChatHmFindOneData` \{Chat\} 채팅 객체
     */
    apiChatHmFindOne: (query: ApiChatHmFindOneParams, params: RequestParams = {}) =>
      this.request<ApiChatHmFindOneData, any>({
        path: `/v3/api/chat/hm/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatHmCount
     * @summary 병원 상담 모바일 앱 - 채팅방 내 전체 채팅내역 수 조회
     * @request GET:/v3/api/chat/hm/count
     * @secure
     * @response `200` `ApiChatHmCountData` 전체 채팅 수
     */
    apiChatHmCount: (query: ApiChatHmCountParams, params: RequestParams = {}) =>
      this.request<ApiChatHmCountData, any>({
        path: `/v3/api/chat/hm/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatHmRemove
     * @summary 병원 상담 모바일 앱 - 채팅의 삭제 여부 수정. 현재는 전송 실패 케이스에 대해서만 삭제 가능
     * @request POST:/v3/api/chat/hm/remove
     * @secure
     * @response `200` `ApiChatHmRemoveData` \{Chat\} 삭제된 채팅 객체
     */
    apiChatHmRemove: (
      data: {
        /** 삭제하고자 하는 채팅 객체의 ID */
        _id: string;
        /** 삭제 여부 */
        isRemoved: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatHmRemoveData, any>({
        path: `/v3/api/chat/hm/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ApiChatHmTranslate
     * @summary 병원 상담 모바일 앱 - 채팅방 내 채팅 즉시 번역
     * @request POST:/v3/api/chat/hm/translate
     * @secure
     * @response `200` `ApiChatHmTranslateData` \{Chat\} 전송된 Chat 객체
     */
    apiChatHmTranslate: (
      data: {
        /** (required) 번역할 채팅 ObjectId */
        chatID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatHmTranslateData, any>({
        path: `/v3/api/chat/hm/translate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name TranslateControllerTranslateContent
     * @summary 채팅방 메세지 내용 번역
     * @request POST:/v3/api/chat/translate/content
     * @secure
     * @response `200` `TranslateControllerTranslateContentData` success
     */
    translateControllerTranslateContent: (
      data: TranslateControllerTranslateContentBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<TranslateControllerTranslateContentData, any>({
        path: `/v3/api/chat/translate/content`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ChatControllerPagination
     * @summary 채팅 페이지네이션
     * @request GET:/v3/api/chat/pagination
     * @secure
     * @response `200` `ChatControllerPaginationData` success
     */
    chatControllerPagination: (query: ChatControllerPaginationParams, params: RequestParams = {}) =>
      this.request<ChatControllerPaginationData, any>({
        path: `/v3/api/chat/pagination`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Chat
     * @name ChatControllerSearch
     * @summary 채팅방 내 키워드 검색
     * @request GET:/v3/api/chat/el/find/search
     * @secure
     * @response `200` `ChatControllerSearchData` success
     */
    chatControllerSearch: (query: ChatControllerSearchParams, params: RequestParams = {}) =>
      this.request<ChatControllerSearchData, any>({
        path: `/v3/api/chat/el/find/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 채팅 방에서 최신 상담 자동화 알고리즘 메시지에 대한 상담 가이드 및 마지막 상담 목록, 마케팅 자동화 메시지의 목록을 조회합니다.
     *
     * @tags V3-Chat
     * @name ChatControllerFindConsultationGuides
     * @summary 특정 채팅 방 최신 상담 자동화 알고리즘 메시지에 대한 상담 가이드 및 마지막 상담 목록, 마케팅 자동화 메시지의 목록 조회
     * @request GET:/v3/api/chat/consultation-guides
     * @secure
     * @response `200` `ChatControllerFindConsultationGuidesData` success
     */
    chatControllerFindConsultationGuides: (
      query: ChatControllerFindConsultationGuidesParams,
      params: RequestParams = {},
    ) =>
      this.request<ChatControllerFindConsultationGuidesData, any>({
        path: `/v3/api/chat/consultation-guides`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 모바일 앱 - 홈케어 상품 페이지에서 "채팅 상담 진행하기" 선택 시 채팅 생성
     *
     * @tags V3-Chat
     * @name ChatMCreateHAftercareHandler
     * @summary 모바일 앱 - 홈케어 상품 페이지에서 "채팅 상담 진행하기" 선택 시 채팅 생성 : ts
     * @request POST:/v3/api/Chat/m/create/haftercare
     * @secure
     * @response `200` `ChatMCreateHAftercareHandlerData` success
     */
    chatMCreateHAftercareHandler: (data: ChatMCreateHAftercareHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ChatMCreateHAftercareHandlerData, any>({
        path: `/v3/api/Chat/m/create/haftercare`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 모바일 앱 이벤트 페이지에서 "채팅 상담 진행하기" 선택 시 채팅 생성
     *
     * @tags V3-Chat
     * @name ChatMCreateHEventHandler
     * @summary 모바일 앱 이벤트 페이지에서 "채팅 상담 진행하기" 선택 시 채팅 생성 : ts
     * @request POST:/v3/api/Chat/m/create/hevent
     * @secure
     * @response `200` `ChatMCreateHEventHandlerData` success
     */
    chatMCreateHEventHandler: (data: ChatMCreateHEventHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ChatMCreateHEventHandlerData, any>({
        path: `/v3/api/Chat/m/create/hevent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 모바일 앱 메인 페이지에서 "예약 > 채팅으로 예약" 선택 시 채팅 생성
     *
     * @tags V3-Chat
     * @name ChatMCreateReservationHandler
     * @summary 모바일 앱 메인 페이지에서 "예약 > 채팅으로 예약" 선택 시 채팅 생성 : ts
     * @request POST:/v3/api/Chat/m/create/reservation
     * @secure
     * @response `200` `ChatMCreateReservationHandlerData` success
     */
    chatMCreateReservationHandler: (data: ChatMCreateReservationHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ChatMCreateReservationHandlerData, any>({
        path: `/v3/api/Chat/m/create/reservation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅 객체의 수 조회
     *
     * @tags V3-Chat
     * @name ChatMCountHandler
     * @summary 채팅 객체의 수 조회 : ts
     * @request GET:/v3/api/Chat/m/count
     * @secure
     * @response `200` `ChatMCountHandlerData` success
     */
    chatMCountHandler: (query: ChatMCountHandlerParams, params: RequestParams = {}) =>
      this.request<ChatMCountHandlerData, any>({
        path: `/v3/api/Chat/m/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅 객체의 조회
     *
     * @tags V3-Chat
     * @name ChatMFindHandler
     * @summary 채팅 객체의 조회 : ts
     * @request GET:/v3/api/Chat/m/find
     * @secure
     * @response `200` `ChatMFindHandlerData` success
     */
    chatMFindHandler: (query: ChatMFindHandlerParams, params: RequestParams = {}) =>
      this.request<ChatMFindHandlerData, any>({
        path: `/v3/api/Chat/m/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 채팅 방에서 최신 상담 자동화 알고리즘 메시지에 대한 상담 가이드 및 마지막 상담, 마케팅 자동화 메시지를 조회합니다.
     *
     * @tags V3-Chat
     * @name ChatRoomsLatestConsultationGuideHandler
     * @summary 특정 채팅 방 최신 상담 자동화 알고리즘 메시지에 대한 상담 가이드 및 마지막 상담, 마케팅 자동화 메시지 조회
     * @request GET:/v3/api/Chat/el/consultation-guide-for-last-algorithm-message
     * @secure
     * @response `200` `ChatRoomsLatestConsultationGuideHandlerData` success
     */
    chatRoomsLatestConsultationGuideHandler: (
      query: ChatRoomsLatestConsultationGuideHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomsLatestConsultationGuideHandlerData, any>({
        path: `/v3/api/Chat/el/consultation-guide-for-last-algorithm-message`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 채팅 방에서 최신 상담 자동화 알고리즘 메시지에 대한 상담 가이드 및 마지막 상담 목록, 마케팅 자동화 메시지의 목록을 조회합니다.
     *
     * @tags V3-Chat
     * @name ChatRoomsConsultationGuidesHandler
     * @summary 특정 채팅 방 최신 상담 자동화 알고리즘 메시지에 대한 상담 가이드 및 마지막 상담 목록, 마케팅 자동화 메시지의 목록 조회
     * @request GET:/v3/api/chat/el/consultation-guides
     * @secure
     * @response `200` `ChatRoomsConsultationGuidesHandlerData` success
     */
    chatRoomsConsultationGuidesHandler: (query: ChatRoomsConsultationGuidesHandlerParams, params: RequestParams = {}) =>
      this.request<ChatRoomsConsultationGuidesHandlerData, any>({
        path: `/v3/api/chat/el/consultation-guides`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description SaaS 대상 자동 응대 채팅을 일괄적으로 발송하는 배치를 수행합니다.
     *
     * @tags V3-Chat
     * @name AnsweringChatsProcessingBatchHandler
     * @summary SaaS 대상 자동 응대 채팅 일괄 발송 배치 수행
     * @request POST:/v3/api/Chat/el/answering-chats/for-saas/batch
     * @secure
     * @response `200` `AnsweringChatsProcessingBatchHandlerData` success
     */
    answeringChatsProcessingBatchHandler: (params: RequestParams = {}) =>
      this.request<AnsweringChatsProcessingBatchHandlerData, any>({
        path: `/v3/api/Chat/el/answering-chats/for-saas/batch`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description V1 대상 자동 응대 채팅을 일괄적으로 발송하는 배치를 수행합니다.
     *
     * @tags V3-Chat
     * @name AnsweringChatsProcessingBatchForV1Handler
     * @summary V1 대상 자동 응대 채팅 일괄 발송 배치 수행
     * @request POST:/v3/api/Chat/el/answering-chats/for-v1/batch
     * @secure
     * @response `200` `AnsweringChatsProcessingBatchForV1HandlerData` success
     */
    answeringChatsProcessingBatchForV1Handler: (params: RequestParams = {}) =>
      this.request<AnsweringChatsProcessingBatchForV1HandlerData, any>({
        path: `/v3/api/Chat/el/answering-chats/for-v1/batch`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
